import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { ToastContainer } from 'react-toastify';

import i18n from 'i18next';

if (!localStorage.getItem("selectedLanguage")) {
  localStorage.setItem("selectedLanguage", "1");
}
i18n.changeLanguage(localStorage.getItem("selectedLanguage") || "1");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <>
    <ToastContainer theme='colored' />
    <Provider store={store}>
      <App />
    </Provider>
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
